import { FORM_BUILDER_FIELD_TYPE } from "@loanbossinc/component-library";

import {
  shouldShowParPrepaymentPeriodEdit,
  shouldShowSpreadMaintenancePeriodEdit,
  shouldShowYieldMaintenancePeriodEdit,
  shouldShowMakeWholePeriodEdit,
  shouldShowSuccessorBorrowerDesignationEdit,
  shouldShowCalculationMethodologyEdit,
  shouldShowReinvestmentRateAssumptionsEdit,
  shouldShowPVRateAssumptionsEdit,
  shouldShowDefeasanceCollateralEdit,
  shouldShowSecuritiesStructureEdit,
  shouldShowPortfolioMaturityEdit,
  shouldShowDefeasanceFeeEdit,
  shouldShowSecuritizationEdit,
  shouldShowOtherEdit,
  shouldShowSecuritizationDate
} from "./section-details-rows-logic";

export const rows = {
  title: {
    isTitle: true,
    cells: [
      {
        type: FORM_BUILDER_FIELD_TYPE.TEXT,
        value: "Prepayment Details",
        style: {
          marginLeft: "0",
          fontFamily: "Work Sans",
          fontStyle: "normal",
          fontWeight: "500",
          fontSize: "16px",
          lineHeight: "14px",
          textTransform: "uppercase",
          color: "#000000",
          marginBottom: "10px"
        }
      },
      {
        type: FORM_BUILDER_FIELD_TYPE.REFERENCE,
        referencedFieldPath: "loans.prepaymentdetails.header"
      }
    ]
  },
  prepaymentType: {
    label: "Prepayment Type",
    cells: [
      {
        type: FORM_BUILDER_FIELD_TYPE.TYPEAHEAD,
        key: "prepaymentTypeId",
        name: "prepaymentTerms.prepaymentTypeId",
        variant: "filled",
        parentId: "prepaymentTypes",
        options: [],
        displayWith: option => option.name,
        setValueWith: option => option.id,
        onChange: value => {
          console.log("onChange", { value });
        }
      },
      {
        type: FORM_BUILDER_FIELD_TYPE.REFERENCE,
        referencedFieldPath: "loans.prepaymentTerms.prepaymentType"
      }
    ]
  },
  exitFee: {
    label: "Exit fee",
    cells: [
      {
        type: FORM_BUILDER_FIELD_TYPE.PERCENT,
        name: "prepaymentTerms.exitFee",
        variant: "filled",
        decimals: 2,
        multiline: true
      },
      {
        type: FORM_BUILDER_FIELD_TYPE.REFERENCE,
        referencedFieldPath: "loans.prepaymentTerms.exitFee"
      }
    ]
  },
  lockoutPeriod: {
    label: "Lockout period",
    cells: [
      {
        type: FORM_BUILDER_FIELD_TYPE.STRING,
        name: "prepaymentTerms.lockoutPeriod",
        variant: "filled",
        multiline: true
      },
      {
        type: FORM_BUILDER_FIELD_TYPE.REFERENCE,
        referencedFieldPath: "loans.prepaymentTerms.lockoutPeriod"
      }
    ]
  },
  parPrepaymentPeriod: {
    label: "Par prepayment period",
    isVisible: data => shouldShowParPrepaymentPeriodEdit(data),
    cells: [
      {
        type: FORM_BUILDER_FIELD_TYPE.STRING,
        name: "prepaymentTerms.parPrepaymentPeriod",
        variant: "filled",
        multiline: true
      },
      {
        type: FORM_BUILDER_FIELD_TYPE.REFERENCE,
        referencedFieldPath: "loans.prepaymentTerms.parPrepaymentPeriod"
      }
    ]
  },
  spreadMaintenancePeriod: {
    label: "Spread Maintenance Period",
    isVisible: data => shouldShowSpreadMaintenancePeriodEdit(data),
    cells: [
      {
        type: FORM_BUILDER_FIELD_TYPE.STRING,
        name: "prepaymentTerms.spreadMaintenance",
        variant: "filled",
        multiline: true
      },
      {
        type: FORM_BUILDER_FIELD_TYPE.REFERENCE,
        referencedFieldPath: "loans.prepaymentTerms.spreadMaintenance"
      }
    ]
  },
  noticePeriod: {
    label: "Notice Period",
    cells: [
      {
        type: FORM_BUILDER_FIELD_TYPE.STRING,
        name: "prepaymentTerms.noticePeriod",
        variant: "filled",
        multiline: true
      },
      {
        type: FORM_BUILDER_FIELD_TYPE.REFERENCE,
        referencedFieldPath: "loans.prepaymentTerms.noticePeriod"
      }
    ]
  },
  yieldMaintenancePeriod: {
    label: "Yield Maintenance Period",
    isVisible: data => shouldShowYieldMaintenancePeriodEdit(data),
    cells: [
      {
        type: FORM_BUILDER_FIELD_TYPE.STRING,
        name: "prepaymentTerms.yieldMaintenancePeriod",
        variant: "filled",
        multiline: true
      },
      {
        type: FORM_BUILDER_FIELD_TYPE.REFERENCE,
        referencedFieldPath: "loans.prepaymentTerms.yieldMaintenancePeriod"
      }
    ]
  },
  makeWholePeriod: {
    label: "Make Whole Period",
    isVisible: data => shouldShowMakeWholePeriodEdit(data),
    cells: [
      {
        type: FORM_BUILDER_FIELD_TYPE.STRING,
        name: "prepaymentTerms.makeWholePeriod",
        variant: "filled",
        multiline: true
      },
      {
        type: FORM_BUILDER_FIELD_TYPE.REFERENCE,
        referencedFieldPath: "loans.prepaymentTerms.makeWholePeriod"
      }
    ]
  },
  successorBorrowerDesignation: {
    label: "Successor Borrower Designation",
    isVisible: data => shouldShowSuccessorBorrowerDesignationEdit(data),
    cells: [
      {
        type: FORM_BUILDER_FIELD_TYPE.STRING,
        name: "prepaymentTerms.successorBorrowerDesignation",
        variant: "filled",
        multiline: true
      },
      {
        type: FORM_BUILDER_FIELD_TYPE.REFERENCE,
        referencedFieldPath: "loans.prepaymentTerms.successorBorrowerDesignation"
      }
    ]
  },
  calculationMethodology: {
    label: "Calculation Methodology",
    isVisible: data => shouldShowCalculationMethodologyEdit(data),
    cells: [
      {
        type: FORM_BUILDER_FIELD_TYPE.STRING,
        name: "prepaymentTerms.calculationMethodology",
        variant: "filled",
        multiline: true
      },
      {
        type: FORM_BUILDER_FIELD_TYPE.REFERENCE,
        referencedFieldPath: "loans.prepaymentTerms.calculationMethodology"
      }
    ]
  },
  reinvestmentRateAssumptions: {
    label: "Reinvestment Rate Assumptions",
    isVisible: data => shouldShowReinvestmentRateAssumptionsEdit(data),
    cells: [
      {
        type: FORM_BUILDER_FIELD_TYPE.STRING,
        name: "prepaymentTerms.reinvestmentRateAssumption",
        variant: "filled",
        multiline: true
      },
      {
        type: FORM_BUILDER_FIELD_TYPE.REFERENCE,
        referencedFieldPath: "loans.prepaymentTerms.reinvestmentRateAssumption"
      }
    ]
  },
  pvRateAssumptions: {
    label: "PV Rate Assumptions",
    isVisible: data => shouldShowPVRateAssumptionsEdit(data),
    cells: [
      {
        type: FORM_BUILDER_FIELD_TYPE.STRING,
        name: "prepaymentTerms.pvRateAssumption",
        variant: "filled",
        multiline: true
      },
      {
        type: FORM_BUILDER_FIELD_TYPE.REFERENCE,
        referencedFieldPath: "loans.prepaymentTerms.pvRateAssumption"
      }
    ]
  },
  defeasanceCollateral: {
    label: "Defeasance Collateral",
    isVisible: data => shouldShowDefeasanceCollateralEdit(data),
    cells: [
      {
        type: FORM_BUILDER_FIELD_TYPE.STRING,
        name: "prepaymentTerms.defeasanceCollateral",
        variant: "filled",
        multiline: true
      },
      {
        type: FORM_BUILDER_FIELD_TYPE.REFERENCE,
        referencedFieldPath: "loans.prepaymentTerms.defeasanceCollateral"
      }
    ]
  },
  securitiesStructure: {
    label: "Securities Structure",
    isVisible: data => shouldShowSecuritiesStructureEdit(data),
    cells: [
      {
        type: FORM_BUILDER_FIELD_TYPE.STRING,
        name: "prepaymentTerms.securitiesStructure",
        variant: "filled",
        multiline: true
      },
      {
        type: FORM_BUILDER_FIELD_TYPE.REFERENCE,
        referencedFieldPath: "loans.prepaymentTerms.securitiesStructure"
      }
    ]
  },
  portfolioMaturity: {
    label: "Portfolio Maturity",
    isVisible: data => shouldShowPortfolioMaturityEdit(data),
    cells: [
      {
        type: FORM_BUILDER_FIELD_TYPE.STRING,
        name: "prepaymentTerms.portfolioMaturity",
        variant: "filled",
        multiline: true
      },
      {
        type: FORM_BUILDER_FIELD_TYPE.REFERENCE,
        referencedFieldPath: "loans.prepaymentTerms.portfolioMaturity"
      }
    ]
  },
  defeasanceFee: {
    label: "Defeasance Fee",
    isVisible: data => shouldShowDefeasanceFeeEdit(data),
    cells: [
      {
        type: FORM_BUILDER_FIELD_TYPE.STRING,
        name: "prepaymentTerms.defeasanceFee",
        variant: "filled",
        multiline: true
      },
      {
        type: FORM_BUILDER_FIELD_TYPE.REFERENCE,
        referencedFieldPath: "loans.prepaymentTerms.defeasanceFee"
      }
    ]
  },
  securitization: {
    label: "Securitization",
    isVisible: data => shouldShowSecuritizationEdit(data),
    cells: [
      {
        type: FORM_BUILDER_FIELD_TYPE.SWITCH,
        name: "prepaymentTerms.isSecuritized",
        variant: "filled",
        hideLabel: true,
        label: "Yes",
        altlabel: "No"
      },
      {
        type: FORM_BUILDER_FIELD_TYPE.DATE,
        name: "prepaymentTerms.securitizationDate",
        variant: "filled",
        hideLabel: false,
        hideDay: true,
        label: "Securitization Date",
        style: { marginTop: "16px" },
        isVisible: data => shouldShowSecuritizationDate(data)
      }
    ]
  },
  other: {
    label: "Other",
    isVisible: data => shouldShowOtherEdit(data),
    cells: [
      {
        type: FORM_BUILDER_FIELD_TYPE.STRING,
        name: "prepaymentTerms.other",
        variant: "filled",
        multiline: true
      },
      {
        type: FORM_BUILDER_FIELD_TYPE.REFERENCE,
        referencedFieldPath: "loans.prepaymentTerms.other"
      }
    ]
  }
};
